import apiClient from '@/services/axios'

export async function post(date, venueDetailsIds) {
  //date format: YYYY-MM-DD
  var response = await apiClient.post(process.env.VUE_APP_MARCOM_API_BASE_URL + `/admin/venue-details/booking-percentage-by-venues`,
    {
      date: date,
      venueDetailIds: venueDetailsIds
    });

  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to get booking percentage');
}
